export default {
  websiteBaseUrl: 'http://localhost:3000',
  apiBaseUrl: 'https://www.roomvu.com/api',
  dashboardBaseUrl: 'http://localhost:3000/dashboard',
  imgBaseUrl: 'https://img.roomvu.com/',
  useProxyForApiCall: true,
  auth: {
    loginUrl: 'https://www.roomvu.com/login',
    registerUrl: 'https://www.roomvu.com/register',
    loginApiUrl: '/user/login',
    userAuthenticationUrl: '/user/get',
  },
  googleCaptcha: {
    siteKey: '6LeuuJcUAAAAAJtpfdUpKvjxk62bbz3KCNVfGkuz',
  },
  webEngage: {
    licenseCode: '82617805',
  },
  intercom: {
    IntercomAppID: 'XXXXXXXXX',
  },
  intrack: {
    IntrackAppKey: 'XXXXXXXXX',
    IntrackAuthKey: 'XXXXXXXXX',
    IntrackPublicKey: 'XXXXXXXXX',
  },
  clarity: {
    projectId: 'XXXXXXXXXX',
  },
  sentry: {
    DSN: 'https://0f2b2605c4334568a8e46d435cc7f6f1@sentry.roomvu.com/5',
    environment: 'development',
  },
};
